exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".payment{color:red}payment .outcome{float:left;width:100%;padding-top:8px;min-height:24px;text-align:center}payment .error,payment .success{display:none;font-size:13px}payment .error.visible,payment .success.visible{display:inline}payment .error{color:#e4584c}payment .success{color:#666ee8}payment .success .token{font-weight:500;font-size:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/onboarding/payment/payment.scss
// module id = 468
// module chunks = 0